import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@packages/api';

async function fetchTranscriptSessionForCall(callId: number) {
  const res = await apiFetch(`/api/v17/transcribe/sessions/call/${callId}`);
  if (!res.ok) throw new Error(`Failed to fetch transcript session: ${res.status}`);
  return res.json();
}

async function fetchTranscriptSessionForMeeting(meetingId: string) {
  const res = await apiFetch(`/api/v17/transcribe/sessions/meeting/${meetingId}`);
  if (!res.ok) throw new Error(`Failed to fetch transcript session: ${res.status}`);
  return res.json();
}

export function useTranscriptSession(callId: number, meetingId: string | undefined) {
  return useQuery({
    queryKey: ['transcriptSession', callId, meetingId],
    queryFn: () =>
      meetingId
        ? fetchTranscriptSessionForMeeting(meetingId)
        : fetchTranscriptSessionForCall(callId),
    enabled: callId > 0,
    retry: false,
    refetchInterval: (query) => {
      const data = query.state.data;
      const isAnalyzing = data?.transcriptAnalyses?.some(
        (a: { analysisStatus: string }) =>
          a.analysisStatus === 'in_progress' || a.analysisStatus === 'pending'
      );
      return isAnalyzing ? 5000 : false;
    },
  });
}

async function fetchTranscriptAnalysis(id: string) {
  const res = await apiFetch(`/api/v17/transcribe/analyses/${id}`);
  if (!res.ok) throw new Error(`Failed to fetch transcript analysis: ${res.status}`);
  return res.json();
}

export function useTranscriptAnalysis(analysisId: string | undefined) {
  return useQuery({
    queryKey: ['transcriptAnalysis', analysisId],
    queryFn: () => fetchTranscriptAnalysis(analysisId!),
    enabled: !!analysisId,
  });
}
